import {computed, ref} from "vue";
import useUser from "./UserComposition";

const useVoiceTheme = (siteUrl, userComposition = useUser()) => {

  // エラー情報
  const errors = ref({});

  // お題
  const voiceTheme = ref({
    id: 0,
    title: '',
    thumbnail: '',
    voice_admin_id: 0,
    status: 0,
    start_at: '',
    end_at: '',
    voice_gift_id: 0,
    voice_gift_limit: 0,
    add_point: 0,
    question_type: 0,
    question_title: '',
    enable_multiple_choice: 0,
    is_hot: 0,
    confirmation_at: '',
    created_at: '',
    updated_at: '',
    deleted_at: '',
    is_confirmed: false,
    voice_admin: {
      id: 0,
      name: '',
      created_at: '',
      updated_at: '',
      deleted_at: '',
    },
    voice_gift: {
      id: 0,
      name: '',
      type: 0,
      price: 0,
      created_at: '',
      updated_at: '',
      deleted_at: '',
    },
    voices: [],
    voice_theme_choices: [],
  });

  /**
   * POST 送信時に必須の HTTP ヘッダー設定を返す
   * @returns {{"X-Requested-With": string, "X-CSRF-TOKEN"}}
   * @private
   */
  const _getHeader = () => {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
    };
  };

  // お題の初期化
  const initVoiceTheme = (data) => {
    voiceTheme.value = {
      ...voiceTheme.value,
      ...data,
    };
  };

  // 回答を送信する
  const setAnswer = async (nicknameId, answer, choiceIds, isValid = false) => {
    //送信 body の作成
    const body = new FormData();
    body.append('user_nickname_id', nicknameId);
    body.append('answer', answer);
    for (let i = 0, max = choiceIds.length; i < max; i = (i + 1) | 0) {
      body.append('choices[]', choiceIds[i]);
    }

    // バリデーション目的の場合
    if (isValid) {
      body.append('valid', '1');
    }

    //投稿をサーバーへ依頼する
    try {
      //通信開始
      const response = await fetch(siteUrl+'voice/set-voice/'+voiceTheme.value.id, {
        method: 'post',
        headers: _getHeader(),
        body: body
      });

      //レスポンス異常発生
      if ( ! response.ok) {
        //もし 404 だったらログインしていない
        if (response.status === 404) {
          throw new Error('ログインセッションが切れている可能性があります。恐れ入りますがページをリロードして再度ログインしてください。');
        }

        //エラーメッセージが返っているか判定
        const parameter = await response.json();

        //もしエラーメッセージが存在すれば返す
        if ('errors' in parameter && Array.isArray(parameter.errors)) {
          throw parameter.errors;
        }
        if ('errors' in parameter && typeof parameter.errors === 'object' && parameter.errors !== null) {
          throw Object.keys(parameter.errors).map(key => parameter.errors[key].join("\n"));
        }
        if ('messages' in parameter && Array.isArray(parameter.messages)) {
          throw parameter.messages;
        }

        //もし単発エラーがあれば返す
        if ('message' in parameter && typeof parameter.message === 'string') {
          throw [parameter.message];
        }

        //エラーメッセージを文字列に変換して例外を投げる
        throw new Error('エラーが発生しました。しばらくしてから再度お試しください。');
      }

      //成功を返す
      return true;
    }

      //サーバーとの通信中、なんらかのエラーが発生
    catch (error) {
      console.log(error);
      //恐らく通信途絶
      if (error instanceof TypeError) {
        errors.value = ['ネットワーク接続に失敗しました。'];
      }

      //恐らく意図的な中断
      else if (error instanceof DOMException) {
        errors.value = ['ネットワーク接続が中断されました。'];
      }

      //恐らくサーバーからのメッセージ
      else if (Array.isArray(error)) {
        errors.value = error;
      }

      //恐らくカスタムエラー
      else if (error instanceof Error) {
        errors.value = [error.message];
      }

      //不明
      else {
        errors.value = ['エラーが発生しました。しばらくしてから再度お試しください。'];
      }
    }

    // 失敗を返す
    return false;
  }

  // ユーザが既に回答しているか
  const isAnswered = computed(() => voiceTheme.value.voices.some((voice) => Number(voice.user_id) === Number(userComposition.user.value.id)));

  // 返す
  return {
    errors,
    voiceTheme,
    isAnswered,
    initVoiceTheme,
    setAnswer,
  };

};

//composition のエクスポート
export default useVoiceTheme;

//composition を注入するためのキー
export const USE_VOICE_THEME_KEY = Symbol('useVoiceTheme');
